import type { HTMLAttributes, CSSProperties } from 'react';

type SpinnerSize = 'sm' | 'md' | 'lg';

export interface SpinnerProps extends HTMLAttributes<HTMLDivElement> {
  size?: SpinnerSize;
}

const sizeDimensions: Record<SpinnerSize, number> = {
  sm: 16,
  md: 24,
  lg: 32,
};

export function Spinner({ size = 'md', className = '', style, ...rest }: SpinnerProps) {
  const dimension = sizeDimensions[size];

  const spinnerStyle: CSSProperties = {
    width: dimension,
    height: dimension,
    borderWidth: 2,
    borderStyle: 'solid',
    borderColor: 'rgba(255,255,255,0.2)',
    borderTopColor: '#6366f1',
    borderRadius: '50%',
    ...style,
  };

  return (
    <div
      role="status"
      aria-label="Loading"
      className={['animate-spin', className].filter(Boolean).join(' ')}
      style={spinnerStyle}
      {...rest}
    >
      <span style={{ position: 'absolute', width: 1, height: 1, padding: 0, margin: -1, overflow: 'hidden', clip: 'rect(0,0,0,0)', whiteSpace: 'nowrap', borderWidth: 0 }}>
        Loading...
      </span>
    </div>
  );
}

export default Spinner;
